import React from "react";

const AiScoreRow = ({ aiScore }) => (
  <div className="qp-card-rating-row">
    {/* <span className="qp-ai-score-text">AI Score {aiScore}%</span>
    <span className="qp-rating-divider">|</span> */}
    <span className="qp-tag-external">External</span>
  </div>
);

export default AiScoreRow;

